import * as React from "react";
const SvgFiRrCrm = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-CRM_svg__a)">
      <path
        fill="#062147"
        d="M11 7h-1c-1.103 0-2 .897-2 2v8a1 1 0 1 0 2 0v-3h1c.144 0 .281-.026.42-.042l.821 3.285a1 1 0 0 0 .969.758c.848 0 1.105-.707.971-1.242l-.905-3.621a3.48 3.48 0 0 0 1.224-2.636c0-1.93-1.57-3.5-3.5-3.5zm0 5h-1V9h1c.827 0 1.5.673 1.5 1.5S11.827 12 11 12m-9.001-1.5v4c0 .827.673 1.5 1.5 1.5.71 0 1.328-.505 1.47-1.199a1 1 0 1 1 1.96.399 3.51 3.51 0 0 1-3.43 2.801 3.505 3.505 0 0 1-3.5-3.501v-4A3.504 3.504 0 0 1 3.497 7a3.51 3.51 0 0 1 3.431 2.801 1 1 0 1 1-1.96.398 1.501 1.501 0 0 0-2.969.301m22.017 6.418c.045.55-.306 1.082-.998 1.082-.515 0-.953-.396-.996-.918l-.496-5.997-.991 2.309a1 1 0 0 1-1.837 0l-.974-2.267-.458 5.95a1.01 1.01 0 0 1-1.074.92 1 1 0 0 1-.92-1.074l.67-8.703a1.32 1.32 0 0 1 2.529-.42l1.146 2.666 1.136-2.647a1.325 1.325 0 0 1 1.435-.787c.604.099 1.06.592 1.11 1.202l.718 8.685z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-CRM_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCrm;
